<template>
  <div class="workspace-apps-page">
    <div class="page-header">
      <h1>{{ t('workspaceApps.title') }}</h1>
      <p>{{ t('workspaceApps.subtitle') }}</p>
    </div>
    <div class="page-card">
      <p>{{ t('workspaceApps.placeholder') }}</p>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style scoped>
.workspace-apps-page {
  min-height: 100vh;
  padding: 24px;
  background: var(--bg-primary);
  color: var(--text-primary);
}
.page-header h1 {
  font-size: 28px;
  font-weight: 700;
}
.page-header p {
  color: var(--text-secondary);
}
.page-card {
  margin-top: 20px;
  background: var(--bg-secondary);
  border: 1px solid var(--border-primary);
  border-radius: 12px;
  padding: 16px;
}
</style>
